/*
 * @Author: JamesWong
 * @Description: 应用版本繁体包
 * @Date: 2018-11-29 15:14:04
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-11-29 20:20:05
 */
export default {
  appVersion: '應用版本',
  backstageVersion: '後臺版本',
  enabledIOSVersion: '可使用的IOS版本',
  enabledAndroidVersion: '可使用的安卓版本',
  enabledPadVersion: '可使用的安卓平板版本',
  versionUpdateDesc: '版本更新說明',
  downloadQRcode: '下載二維碼',
  downloadAddress: '下載地址',
  downloadArticle: '詳細反覆運算推文',
  '版本详情': '版本詳情',
  '下载': '下載',
  Close: '关闭',
  '点击详情': '点击详情',
  '未启用': '未启用',
  '可联系商务开通': '可联系商务开通',
  '下载链接': '下载链接'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-hant/appversion.js